import React from 'react';
import { motion } from 'framer-motion';
import { 
  Building, 
  MapPin, 
  Phone, 
  Mail,
  Globe,
  Shield
} from 'lucide-react';

const Impressum = () => {
  return (
    <>

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Impressum
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
              Rechtliche Informationen und Kontaktdaten
            </p>
          </motion.div>
        </div>
      </section>

      {/* Impressum Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {/* Company Information */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                <Building size={28} className="text-blue-600 mr-3" />
                Angaben gemäß § 5 TMG
              </h2>
              
              <div className="bg-gray-50 p-8 rounded-xl space-y-4">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Auto-Glass Mannheim
                  </h3>
                  <p className="text-gray-600">
                    Professionelle Autoglas Reparatur und Austausch
                  </p>
                </div>
                
                <div className="flex items-start space-x-3">
                  <MapPin size={20} className="text-blue-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-gray-900">Anschrift:</p>
                    <p className="text-gray-600">
                      Musterstraße 123<br />
                      68159 Mannheim<br />
                      Deutschland
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <Phone size={20} className="text-blue-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-gray-900">Telefon:</p>
                    <a href="tel:062171895675" className="text-blue-600 hover:text-blue-700">
                      0621 71895675
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <Mail size={20} className="text-blue-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-gray-900">E-Mail:</p>
                    <a href="mailto:info@autoglass-mannheim.de" className="text-blue-600 hover:text-blue-700">
                      info@autoglass-mannheim.de
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <Globe size={20} className="text-blue-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-gray-900">Website:</p>
                    <a href="https://autoglass-mannheim.de" className="text-blue-600 hover:text-blue-700">
                      https://autoglass-mannheim.de
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Legal Representatives */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                <Shield size={28} className="text-blue-600 mr-3" />
                Vertreten durch
              </h2>
              
              <div className="bg-gray-50 p-8 rounded-xl">
                <p className="text-gray-600">
                  <strong>Geschäftsführer:</strong> Max Mustermann<br />
                  <strong>USt-IdNr.:</strong> DE123456789<br />
                  <strong>Steuernummer:</strong> 123/456/78901
                </p>
              </div>
            </motion.div>

            {/* Professional Associations */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Berufsaufsichtsbehörde
              </h2>
              
              <div className="bg-gray-50 p-8 rounded-xl">
                <p className="text-gray-600">
                  <strong>Zuständige Kammer:</strong> Handwerkskammer Mannheim<br />
                  <strong>Berufsbezeichnung:</strong> Kfz-Glaser<br />
                  <strong>Verliehen durch:</strong> Deutschland
                </p>
              </div>
            </motion.div>

            {/* EU Dispute Resolution */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                EU-Streitschlichtung
              </h2>
              
              <div className="bg-gray-50 p-8 rounded-xl">
                <p className="text-gray-600 mb-4">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                  <a href="https://ec.europa.eu/consumers/odr/" className="text-blue-600 hover:text-blue-700 ml-1">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                </p>
                <p className="text-gray-600">
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
              </div>
            </motion.div>

            {/* Consumer Dispute Resolution */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              
              <div className="bg-gray-50 p-8 rounded-xl">
                <p className="text-gray-600 mb-4">
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
                <p className="text-gray-600">
                  <strong>Haftung für Inhalte</strong><br />
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                  Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                  Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                  Tätigkeit hinweisen.
                </p>
              </div>
            </motion.div>

            {/* Copyright */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Urheberrecht
              </h2>
              
              <div className="bg-gray-50 p-8 rounded-xl">
                <p className="text-gray-600 mb-4">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                  dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                  der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                  Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
                <p className="text-gray-600">
                  Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen 
                  Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt 
                  wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter 
                  als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung 
                  aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von 
                  Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
              </div>
            </motion.div>

            {/* Disclaimer */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Haftungsausschluss
              </h2>
              
              <div className="bg-gray-50 p-8 rounded-xl">
                <p className="text-gray-600 mb-4">
                  <strong>Haftung für Links</strong><br />
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                  Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                  Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
                  der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung 
                  auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
                  Verlinkung nicht erkennbar.
                </p>
                <p className="text-gray-600">
                  Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete 
                  Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
                  Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Haben Sie Fragen?
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              Kontaktieren Sie uns gerne bei Fragen zu unseren Dienstleistungen oder rechtlichen Angelegenheiten.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:062171895675"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300 flex items-center justify-center space-x-2"
              >
                <Phone size={24} />
                <span>Jetzt anrufen: 0621 71895675</span>
              </a>
              <a
                href="mailto:info@autoglass-mannheim.de"
                className="bg-transparent border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300"
              >
                E-Mail senden
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Impressum; 